import { useEffect, useRef, useState } from 'react'
import { apiClient } from '../api/client'
import type { AlbumDownloadJob } from '../api/types'

/**
 * ジョブポーリングカスタムフック
 *
 * ジョブIDを指定すると、2秒ごとにステータスをポーリングし、
 * 完了・失敗時に自動停止する。
 */
export function useJobPolling(jobId: string | null, onComplete?: (job: AlbumDownloadJob) => void) {
  const [job, setJob] = useState<AlbumDownloadJob | null>(null)
  const [error, setError] = useState<string | null>(null)
  const intervalRef = useRef<number | null>(null)
  const onCompleteRef = useRef(onComplete)

  useEffect(() => {
    // onCompleteRefを最新の値で更新
    onCompleteRef.current = onComplete
  }, [onComplete])

  useEffect(() => {
    if (!jobId) {
      return
    }

    // 初回即座に取得
    const fetchJob = async () => {
      try {
        const response = await apiClient.getDownloadJobStatus(jobId)
        setJob(response.job)

        // 完了・失敗時にポーリング停止
        if (response.job.status === 'completed' || response.job.status === 'failed') {
          if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
          }

          // コールバック実行
          if (onCompleteRef.current) {
            onCompleteRef.current(response.job)
          }
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'ジョブステータスの取得に失敗しました')
      }
    }

    fetchJob()

    // 2秒ごとにポーリング
    intervalRef.current = setInterval(fetchJob, 2000) as unknown as number

    // クリーンアップ
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [jobId])

  return { job, error }
}
